import { MAIN_LOGO_IMAGE, MAIN_LOGO_IMAGE_NO_TEXT } from "../../constants";

export const MainLogo = (props: any) => {
    const source = props.hideText
        ? MAIN_LOGO_IMAGE_NO_TEXT
        : MAIN_LOGO_IMAGE;

    const style = {
        objectFit: props.resizeMode ?? "center",
        ...(props.style ?? {width:"200px"})
    };

    return (
        <img
            src={source}
            style={style}
            alt="Pappa Squat"
        />
    );
};
